export const validateAddUser = (user) => {
  let errMsg: string;

  if (!/^[a-z0-9_\.]+$/.exec(user.username) || user.username?.length < 4) {
    errMsg =
      'Korisničko ime mora imati barem 4 karaktera, od kojih su dozvoljeni: mala slova, brojevi, tačka i donja crta.';
  } else if (!user.role) {
    errMsg = 'Odaberite ulogu korisnika.';
  } else if (user.role === 'Employee' && (!user.managerId)) {
    errMsg = 'Morate odabrati menadžera.';
  }
  else if (user.role === 'Operater' && !user.operaterId) {
    errMsg = 'Morate uneti Id operatera';
  }

  else {
    errMsg = '';
    return { isValid: true, errMsg };
  }
  return { isValid: false, errMsg };
};

export const validateEditUser = (user) => {
  let errMsg: string;

  if (!/^[a-z0-9_\.]+$/.exec(user.username) || user.username?.length < 4) {
    errMsg =
      'Korisničko ime mora imati barem 4 karaktera, od kojih su dozvoljeni: mala slova, brojevi, tačka i donja crta.';
  } else if (user.firstName?.length < 2 || user.lastName?.length < 2) {
    errMsg = 'Ime i prezime moraju imati barem 2 karaktera.';
  } else if (!user.idCardNo) {
    errMsg = 'Unesite broj lične karte.';
  } else if (user.address?.length < 5) {
    errMsg = 'Unesite ispravnu adresu.';
  } else if (!user.role) {
    errMsg = 'Odaberite ulogu korisnika.';
  } else if (user.role === 'Employee' && !user.managerId) {
    errMsg = 'Morate odabrati menadžera';
  }
  else if (user.role === 'Operater' && !user.operaterId) {
    errMsg = 'Morate uneti Id operatera';
  }

  else {
    errMsg = '';
    return { isValid: true, errMsg };
  }
  return { isValid: false, errMsg };
};

export const validateRoom = (room) => {
  let errMsg: string;
  if (room.roomName?.length < 2) {
    errMsg = 'Unesite ime igraonice.';
  } else if (!room.workingHoursFrom || !room.workingHoursTo) {
    errMsg = 'Unesite radno vreme igraonice.';
  } else if (!room.phone) {
    errMsg = 'Unesite broj telefona';
  } else if (!room.address) {
    errMsg = 'Unesite naziv grada.';
  } else if (!room.managerId) {
    errMsg = 'Morate odabrati menadžera za igraonicu.';
  } else {
    errMsg = '';
    return { isValid: true, errMsg };
  }
  return { isValid: false, errMsg };
};

export const validateVisit = (visit) => {
  let errMsg: string;
  if (!visit.leave) {
    errMsg = 'Unesite vreme izlaska iz igraonice.';
  } else {
    errMsg = '';
    return { isValid: true, errMsg };
  }
  return { isValid: false, errMsg };
};
export const validateRamp = (ramp) => {
  let errMsg: string;
  if (ramp.brojRampe?.length < 4) {
    errMsg = 'Unesite naziv rampe.';

  }
  else if (!ramp.roomId) {
    errMsg = 'Morate odabrati igraonicu.';

  }
  else if ((ramp.izlazna == false && ramp.ulazna == false)) {
    errMsg = 'Morate odabrati Rampu.';

  }
  else {
    errMsg = '';
    return { isValid: true, errMsg };
  }
  return { isValid: false, errMsg };
};
export const validateStaffCard = (staffCard) => {
  let errMsg: string;
  if (staffCard.fullName?.length < 4) {
    errMsg = 'Unesite naziv .';

  }
  else if (staffCard.roomIds === undefined || staffCard.roomIds.length == 0) {
    errMsg = 'Morate odabrati igraonicu.';

  }
  else if ((staffCard.izlazna == false)) {
    errMsg = 'Morate odabrati da li dozvoljenja.';

  }
  else {
    errMsg = '';
    return { isValid: true, errMsg };
  }
  return { isValid: false, errMsg };
};


export const validateZone = (zone) => {
  let errMsg: string;


  if (zone.zoneName === '') {
    errMsg = 'Morate upisati zonu.';
  }


  else if (
    !/^([A-Z][a-zA-Z0-9]{3,})(\s[A-Z]?[a-zA-Z0-9]*)*$/.test(zone.zoneName) ||
    zone.zoneName?.length < 4
  ) {
    errMsg = 'Naziv zone mora imati barem 4 karaktera i početi velikim slovom. Dozvoljeno više reči.';
  }



  // samo cifre
  else if (!/^\d+$/.test(zone.maxChildNumber)) {
    errMsg = 'Dodajte isključivo cifre za maksimalan broj dece.';
  }
  else if (!/^\d+$/.test(zone.maxAdultNumber)) {
    errMsg = 'Dodajte isključivo cifre za maksimalan broj odraslih.';
  }
  else if (!zone.roomId) {
    errMsg = 'Morate odabrati igraonicu.';
  }
  else {
    return { isValid: true, errMsg: '' };
  }

  return { isValid: false, errMsg };
};


export const validateBirthDay = (birthdayAdd) => {
  let errMsg: string;

  if (!birthdayAdd.roomId) {
    errMsg = 'Morate odabrati objekat.';
  }
  else if (!birthdayAdd.BirthdayZoneId) {
    errMsg = 'Morate odabrati zonu.';
  }
  else if (!birthdayAdd.CallDate) {
    errMsg = 'Morate odabrati Datum poziva.';

  }
  else if (!birthdayAdd.AppointmentDate) {
    errMsg = 'Morate odabrati Datum zakazivanja rodjendana.';
  }

  else if (birthdayAdd.AppointmentDate < birthdayAdd.CallDate) {



    errMsg = 'Datutum zakazivanja mora biti veći od datuma zvanja.';
  }

  else if (birthdayAdd.startTimeBirthday === null) {

    errMsg = 'Morate uneti termin održavanja rodjendana.';
  }

  else if (birthdayAdd.endTimeBirthday === '' && birthdayAdd.isFlexible===true) {
    errMsg = 'Morate uneti termin završetka rođendana.';
  }  

  else if (birthdayAdd.Discount < 0 || birthdayAdd.Discount > 100) {
    errMsg = 'Diskont mora biti u opsegu 0 do 100 .';
  }
  else if (birthdayAdd.Discount == null) {
    errMsg = 'Diskont mora biti upisan.';
  }
 
  else if (birthdayAdd.advancePaymentWill != "0" && birthdayAdd.AdvancePayment == 0) {
    errMsg = 'Morate upisati iznos avansa.';
  }
 
  else if (birthdayAdd.CallStatus === null) {
    errMsg = 'Morate uneti status poziva.';
  }
 else if (birthdayAdd.NumberOfBirthday === null) {
    errMsg = 'Morate broj rođendana koji se slavi.';
  }

   else if (birthdayAdd.VisitorId === null) {
    errMsg = 'Morate dodati korisnika';
  }

  else {
    return { isValid: true, errMsg: '' };
  }
  return { isValid: false, errMsg };

};

export const validateBirthDayList = (birthdayListList) => {
  let errMsg: string;
  if (!birthdayListList.roomId) {
    errMsg = 'Morate odabrati objekat.';
  }
  else if (birthdayListList.BirthdayZoneId == null) {
    errMsg = 'Morate odabrati zonu.';
  }
  else if (birthdayListList.appointmentDate < birthdayListList.callDate) {

    errMsg = 'Datutum zakazivanja mora biti veći od datuma zvanja.';
  }
  else if (birthdayListList.BirthDayStart >= birthdayListList.BirthDayEnds) {
    errMsg = 'Termin završetka rodjendana mora biti veći od termina starta rodjendana ';
  }

  else if (birthdayListList.BirthDayStart === '' || birthdayListList.BirthDayEnds === '') {
    errMsg = 'Morate uneti termin održavanja rodjendana.';
  }

  else if (!birthdayListList.plannedPrice) {
    errMsg = 'Morate uneti Planiranu cenu.';
  }
  else if (birthdayListList.discount < 0 || birthdayListList.discount > 100) {
    errMsg = 'Diskont mora biti u opsegu 0 do 100 .';
  }
  else if (birthdayListList.discount == null) {
    errMsg = 'Popust mora biti upisan.';
  }
  else if (birthdayListList.advancePayment < 0 || birthdayListList.advancePayment == null) {
    errMsg = 'Morate upisati iznos avansa (0 ili pozitvan broj).';
  }
  else if (!birthdayListList.plannedChildNumber) {
    errMsg = 'Morate uneti Broj planirane dece.';
  }
  else if (!birthdayListList.presentChildNumber) {
    errMsg = 'Morate uneti Broj prisutne  dece.';
  }
  else if (!birthdayListList.totalPricePaid) {
    errMsg = 'Morate uneti totalnu cenu plaćanja.';
  }
  else {
    return { isValid: true, errMsg: '' };
  }
  return { isValid: false, errMsg };
}





